<template>
  <div id="so-teleport-area" />
</template>
